// https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/foundations/sizes.ts

export const sizes = {
  container: {
    text: '60ch',
    xl: '1600px',
  },
}
